import { isACountry } from '../../../actions';
import getCountriesInGroup from '../../../actions/getCountriesInGroup';

export const resolveActiveGroupHighlight = (state, groupHighlight, locations) => {
  if (!groupHighlight) {
    return false;
  }

  const countriesInGroup = getCountriesInGroup(state, groupHighlight.uid).map((country) => country.iso);
  const hasOverlap = locations.some((location) => isACountry(location) && countriesInGroup.includes(location));

  return hasOverlap ? groupHighlight : false;
};
